<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" :before-close="closeDialog" width="600px" :close-on-click-modal="false">
    <div v-if="curType=='view' && !type" class="warning-content">
      <div class="merchant-box ">已绑定商家码：<span class="merchant-code">{{merchantCode}}</span></div>
    </div>
    <template v-if="type=='change'">
      <el-form :model="form" label-width="150px" ref="ruleForm" :rules="rules">
        <el-form-item label="" prop="">
          <div class="merchant-box">当前绑定商家码：<span class="merchant-code">{{merchantCode}}</span></div>
        </el-form-item>
        <el-form-item label="" prop="merchantNewCode">
          <el-input v-model.trim="form.merchantNewCode" class="y-w-300" clearable placeholder="请输入新的商家编码"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <div v-if="type=='unbind'" class="warning-content">
      <div class="warning-box">
        <img src="@/assets/images/icon/warning_icon.png" alt="" class="warning-icon">
        <span class="warning-text">是否确定解绑？</span>
      </div>
      <div class="warning-desc">解绑后将无法享受北极商家专属价格和服务，菜单将恢复默认状态。</div>
      <div class="merchant-box ">当前绑定商家码：<span class="merchant-code">{{merchantCode}}</span></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button v-if="curType=='view' && !type" type="primary" @click="changeType('unbind')">解绑</el-button>
      <el-button v-if="curType=='view' && !type" type="primary" @click="changeType('change')">换绑</el-button>
      <el-button v-else type="primary" @click="modifyFn">{{type=='change'?'确定换绑':'确定解绑'}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { changeOZonMerchantAccountApi, unbindOZonMerchantAccountApi } from '@/api/waybillPrint/OzonOrderPrint';
export default {
  name: "merchantCodeDialog",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    merchantCode: {
      type: String,
      default: '',
    },
    merchantInfo: {
      type: Object,
      default: () => {},
    },
    curType: {
      type: String,
      default: '',
    }
  },
  data() {
    let valiMerchantCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新的商家编码'));
      } else if (!/^[A-Za-z0-9]{6,12}$/.test(value)) {
        callback(new Error('输入的商家编码有误，请检查。'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: this.isShow,
      form: {
        merchantNewCode: '',
      },
      rules: {
        merchantNewCode: [
          { required: true, message: '请输入新的商家编码', trigger: 'blur' },
          { validator: valiMerchantCode, trigger: ['blur', 'change'] },
        ],
      },
      type: '',
    };
  },
  methods: {
    changeType(type) {
      this.type = type;
    },
    modifyFn() {
      if (this.type == 'change') {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            console.log('this.form', this.form)
            // 换绑商家编码
            this.changeMerchantCodeFn();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        // 解绑商家编码
        this.unbindMerchantCodeFn();
      }
    },
    // 换绑商家编码
    changeMerchantCodeFn() {
      let params = {
        merchantCode: this.form.merchantNewCode,
        id: this.merchantInfo.id,
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      changeOZonMerchantAccountApi(params).then(res => {
        loadingMask.close();
        if (res.success && res.code == 200 ) {
          this.$message.success('更换成功');
          this.closeDialog('refresh');
        } else {
          this.$message.error(res.message || res.data.failMsg || '更换失败')
        }
      }).catch((err)=>{
        loadingMask.close();
        this.$message.error(err.message || '网络异常，请稍候重试')
      })
    },
    // 解绑商家编码
    unbindMerchantCodeFn() {
      let params = {
        id: this.merchantInfo.id,
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      unbindOZonMerchantAccountApi(params).then(res => {
        loadingMask.close();
        if (res.success && res.code == 200 ) {
          this.$message.success('解绑成功');
          this.closeDialog('unbind');
        } else {
          this.$message.error(res.message || res.data.failMsg || '解绑失败')
        }
      }).catch((err)=>{
        loadingMask.close();
        this.$message.error(err.message || '网络异常，请稍候重试')
      })
    },
    closeDialog(refresh) {
      this.dialogVisible = false;
      this.form.merchantNewCode = '';
      this.$emit("closeDialog", refresh);
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.merchant-box {
  width: 300px;
  background: #F2F3F4;
  border-radius: 2px;
  font-size: 14px;
  color: #333333;
  text-align: center;
  .merchant-code {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
  }
}
.warning-content {
  text-align: center;
  .warning-box {
    display: flex;
    align-items: center;
    justify-content: center;
    .warning-icon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .warning-text {
      font-size: 16px;
      font-weight: 600;
      color: #151719;
    }
  }
  .warning-desc {
    margin-top: 16px;
    font-size: 14px;
    color: #151719;
  }
  .merchant-box {
    height: 36px;
    line-height: 36px;
    margin: 16px auto;
  }
}
/deep/ .el-input .el-input__inner {
  text-align: center;
}
/deep/ .el-dialog__footer {
  text-align: center;
}
</style>